// /auth-start — loaded inside the popup window that Teams opens for sign-in.
// It immediately starts the standard MSAL redirect flow, telling Entra to
// return to /auth-end (which must be registered as a SPA redirect URI on the
// frontend app registration).

import React, { useEffect } from 'react';
import { app } from '@microsoft/teams-js';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig, loginRequest } from './msalConfig';

const pageStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#faf7f2',
  color: '#6b6b6b',
  fontSize: 14,
};

export const AuthStart: React.FC = () => {
  useEffect(() => {
    (async () => {
      try {
        await app.initialize();
      } catch {
        /* not fatal — popup may not need the SDK to redirect */
      }
      const params = new URLSearchParams(window.location.search);
      const loginHint = params.get('loginHint') || undefined;

      const pca = new PublicClientApplication({
        ...msalConfig,
        auth: {
          ...msalConfig.auth,
          redirectUri: `${window.location.origin}/auth-end`,
          navigateToLoginRequestUrl: false,
        },
      });
      await pca.initialize();
      await pca.loginRedirect({
        ...loginRequest,
        loginHint,
        prompt: loginHint ? undefined : 'select_account',
      });
    })().catch(console.error);
  }, []);

  return <div style={pageStyle}>Redirecting to Microsoft sign-in&hellip;</div>;
};
